export const SKELETON_THEME: any = {
	'display': 'block',
	'background-color': '#d4d2d2',
	'border-radius': '20px',
	'width': 'calc(100% - 40px)'
}